module.exports = __webpack_public_path__ + "img/only1-generation-home.122e944d.png";